import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'cms-tutorial',
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.scss'],
})
export class TutorialComponent {}
